import { createCellRenderer } from '@fortem-monorepo/react-ag'
import { Badge } from '@fortem-monorepo/react-ui'
import { Smartrade } from '@fortem-monorepo/web-sdk'

export const SmartradeTradesStatusCellRenderer2 = createCellRenderer<
  Smartrade.GetSmartradeTradesData2[number]
>([
  {
    field: 'ordstatus',
    check: (val) => {
      return ['2'].includes(val)
    },
    component: <Badge theme="success">Confirmed</Badge>,
  },
  {
    field: 'ordstatus',
    check: (val) => {
      return ['8'].includes(val)
    },
    component: <Badge theme="destructive">Rejected</Badge>,
  },
  {
    field: 'ordstatus',
    check: (val) => {
      return ['0'].includes(val)
    },
    component: <Badge theme="warning">Pending</Badge>,
  },
  {
    field: 'ordstatus',
    check: (val) => {
      return ['WIP'].includes(val)
    },
    component: <Badge variant={'secondary'}>WIP</Badge>,
  },
])
